import ABCyaLib from '@abcya/abcya_lib';

export default class GameStorage {
  constructor(gamePrefix) {
    this.gamePrefix = gamePrefix;
  }

  setValue (prop, value) {
    ABCyaLib.Storage.saveObject(this.gamePrefix + prop, value);
  }

  getValue (prop) {
    const value = ABCyaLib.Storage.getObject(this.gamePrefix + prop);
    return value;
  }
}


